import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../assets/images/TEMPDEV/facebook-w.png'


const _hoisted_1 = { class: "grid" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "social-flex" }
const _hoisted_4 = {
  key: 0,
  class: "social-media"
}
const _hoisted_5 = { class: "icons" }
const _hoisted_6 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        class: "logo",
        src: _ctx.branding.logo
      }, null, 8, _hoisted_2),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.features.showSociaLogos)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                (_ctx.branding.facebookUrl)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: _ctx.branding.facebookUrl,
                      target: "_blank",
                      rel: "noopener noreferrer"
                    }, [...(_cache[0] || (_cache[0] = [
                      _createElementVNode("img", { src: _imports_0 }, null, -1)
                    ]))], 8, _hoisted_6))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}